import iconSrc from '../../assets/aspa.svg'

const feedbackDesignEditor = {
  itemsPerPage: 2,
  navigationEnabled: true,
  paginationEnabled: true,
  paginationColor: '#d87109',
  paginationActiveColor: '#6c3804'
}

const feedbackContentEditor = {
  iconSrc: iconSrc,
  feedbackList: [],  
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: false,
  loop: true,
  speed: 1000,
  easing: 'ease'
}

for(let i = 1; i < 11; i++) {
  feedbackContentEditor.feedbackList.push({
    title: `O melhor treinamento de todos ${i}!`,
    message: "Desde que entrei para a academia, minha performance física melhorou demais e tive um grande avanço no meus desempenhos não só físicos como também mentais.",
    imageSrc: "https://i.ya-webdesign.com/images/user-icon-png-6.png",
    username: "John Doe",
    role: "CEO at Vue.js",
  })
}

export {
  feedbackDesignEditor,
  feedbackContentEditor,
}
